var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 26.458 26.458",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.736 0l-.34.002A1.357 1.282 0 00.04 1.284v.327a1.357 1.282 0 00-.001.01v15.971a1.357 1.282 0 001.357 1.282h6.329v-.338h.001v-.845H2.407a1.18 1.165 0 01-1.179-1.165V2.341a1.18 1.165 0 011.177-1.156h8.55a1.183 1.168 0 011.182 1.165l.03 10.012H13.351l-.002-.338h.004l-.035-10.74a1.36 1.285 0 00-1.36-1.282h-.34zm5.06 11.476c-.858-.071-1.563.815-.76 1.748l8.778 8.84c.142.003.388 1.604 0 1.504-1.305-.147-2.622-.049-3.936 0-1.234 0-2.005.804-1.848 1.88 1.628-.03 3.177-.366 4.905-.026.181 0 .86.888 1.659.895 1.648.181 3.318.196 5.017 0 1.143-.02 3.687-3.687 5.53-5.53.304-.304.436-.825 0-1.58l-4.775-6.116c-.45-.411-1.372.278-1.608 1.01-.876.134-1.371.028-2.234.07-.376 0-.21 1.57-.556 1.567-1.067.081-1.96-.32-2.33.075-.344.382-.153 1.182-.067 1.844 0 .207-.547.601-1.149 0l-5.93-5.93.162.172c-.27-.27-.572-.4-.858-.424z",
    fill: "#a2a0aa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraw);
export default __webpack_public_path__ + "static/media/draw.733461e1a7cca6f5b027091e439209bd.svg";
export { ForwardRef as ReactComponent };